import { toast } from 'react-toastify';
import { buildLink, copyToClipboard } from '@/components/util/all';

export const takePositionData = ({ slug, matterId, sweep, rotation }: { slug: any; matterId: any; sweep: any; rotation: any }) => {
  const segmants = window.location.href.split('/');
  const id = segmants[segmants.length - 1].split('?')[0];
  if (slug === id || matterId === id) {
    copyToClipboard(buildLink(sweep, rotation));
    toast.success('Copied current position');
  } else {
    toast.error('Cannot copy position in a tour that was reached through the menu, please go to this tour page directly and copy positions from there using CTRL+Y');
  }
};
